import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance } from 'axios';
import { attachRecaptchaInterceptor } from '../recaptcha';

const DEFAULT_EVENT_URL = 'https://dev-event.skin-seoul.com';

let hasWarnedMissingEnv = false;

const getEventBaseURL = (): string => {
  const url = env('NEXT_PUBLIC_ENV_EVENT_ORIGIN');
  if (!url && process.env.NODE_ENV !== 'development' && !hasWarnedMissingEnv) {
    hasWarnedMissingEnv = true;
    console.warn('[eventClient] NEXT_PUBLIC_ENV_EVENT_ORIGIN is not set, falling back to dev URL');
  }
  return url || DEFAULT_EVENT_URL;
};

export const createSkinSeoulEventClient = (_baseURL?: string): AxiosInstance => {
  const initialBaseURL = _baseURL ?? getEventBaseURL();

  const instance = axios.create({
    baseURL: initialBaseURL,
    withCredentials: true,
    adapter: 'fetch',
  });

  instance.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
      const currentBaseURL = getEventBaseURL();
      const configBaseURL = config.baseURL || instance.defaults.baseURL;

      if (currentBaseURL !== DEFAULT_EVENT_URL && configBaseURL !== currentBaseURL) {
        return { ...config, baseURL: currentBaseURL };
      }
    }
    return config;
  });

  attachRecaptchaInterceptor(instance);

  return instance;
};

export let eventClient: AxiosInstance = createSkinSeoulEventClient();

export const setEventClient = (instance: AxiosInstance) => {
  eventClient = instance;
};
